<template>
    <div class="wrap">
        <div class="content" :style="{height: tab==1?'16.2rem':tab==2?'19.9rem':tab==3?'21rem':'100vh'}">
            <base-header :name="user_name" :topOnly="flag_top" :account_list="account_list"></base-header>
            <div class="main_time"></div>
            <ul class="tab-ul">
                <li :class="`tab-li tab-li-${item} ${tab==item?'choosed':''}`" v-for="item in 4" :key="item" @click="change_tab(item)"></li>
            </ul>
            <div class="part part-1" v-if="tab==1">
                <div class="title title1"></div>
                <div class="part-content">
                    <!-- 每日任务 -->
                    <div class="task-list">
                        <div :class="`task-item task-item${index}`" v-for="(item, index) in day_list" :key="index">
                            <div class="img">
                                <img src="@/assets/img/winter/chance.png" alt />
                            </div>
                            <div class="name">{{item.packet_name}}</div>
                            <div :class="'btn btn1 '+(is_signed==1?'over':is_signed==0?'get':'')" @click="to_sign()" v-if="index==0"></div>
                            <div :class="'btn btn2 '+ item.status" v-else @click="open_packet(item, index)"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="part part-2" v-else-if="tab==2">
                <div class="title title2"></div>
                <div class="board">
                    <div :class="'cell cell-'+ index" v-for="(item, index) in goodsList" :key="index">
                        <div :class="'current current-'+ index" v-if="index == i"></div>
                        <img :src="require(`@/assets/img/winter/gift/${index%3==0?index:(index%6)}.png`)" alt srcset />
                        <div class="chess-box" v-if="index == i">
                            <div class="chess"></div>
                            <div class="chess-shadow"></div>
                        </div>
                    </div>
                    <div class="info">
                        <p>
                            <span>点数为 6</span>！可获得对应奖励，<span>并停留；</span>
                        </p>
                        <p><em>其他点数</em>，可获得对应奖励，<em>并返回上一停留点。</em></p>
                    </div>
                    <div class="dice">
                        <img id="dice" :src="require(`@/assets/img/winter/dice/${dice_url}`)" alt />
                    </div>
                    <div class="amount">
                        剩余机会：{{chance_amount}}
                        <span>拥有雪花：{{snow_amount}}</span>
                    </div>
                </div>
                <div :class="`btn ${chance_amount>0?'get':''}`" @click="rollDice()"></div>
                <div class="zx" v-if="fd_item.status=='get'" @click="pick_zx()"></div>
            </div>
            <div class="part part-3" v-else-if="tab==3">
                <div class="title title3"></div>
                <p class="part-tip">
                    拥有雪花：
                    <span>{{snow_amount}}</span>&nbsp;个
                </p>
                <div class="part-content">
                    <div class="exchange-list">
                        <div :class="`exchange-item exchange${d}`" v-for="(i,d) in exchange_list" :key="d">
                            <div class="exchange-name">
                                <p>{{i.packet_name}}</p>
                            </div>
                            <div :class="'exchange-img exchange'+d">
                                <img :src="'https://cdn.09game.com/resources/item/dj_'+i.items[0].id+'_200.png'" :title="i.packet_name" alt />
                            </div>
                            <div class="other">
                                <span class="exchange-reward">{{'雪花*'+i.count+'个'}}</span>
                            </div>
                            <div :class="'btn '+(i.have?'over':i.count <= snow_amount ?'get':'')" @click="exchange(i, d)"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="part part-4" v-else-if="tab==4">
                <div class="title title4"></div>
                <ul class="log-ul" v-if="log_list.length>0">
                    <li class="log-li" v-for="(item, index) in log_list" :key="index">
                        <div class="img">
                            <img src="@/assets/img/winter/gift/0.png" alt v-if="item.getId == 916104" />
                            <img :src="`https://cdn.09game.com/resources/item/dj_${item.getId}_200.png`" title alt v-else />
                        </div>
                        <div class="name">{{item.getMsg}}</div>
                        <div class="time">{{item.create_time}}</div>
                        <div class="ex">
                            {{item.type==1?'玩转好礼':(item.item_id==916104 ? '自选礼包': item.item_id>=916105 && item.item_id<=916108 ? '奖励兑换':
                            item.item_id>=916102 && item.item_id<=916103 ? '福利任务': item.item_id==916101 ? '每日签到':'') }}
                        </div>
                    </li>
                </ul>
                <div class="nodata" v-else>暂无记录</div>
                <div class="info" v-if="log_list.length>0">仅展示最近50条获奖记录</div>
            </div>

            <div class="part explain" v-if="tab<4">
                <div class="title"></div>
                <p>
                    <i class="i1"></i>玩家需要关注《09电竞》公众号、并绑定平台账号后才能参加活动。
                </p>
                <p>
                    <i class="i2"></i>平台等级≥20级的玩家才可进行签到，每天00:00之后可以进行当日签到
                </p>
                <p>
                    <i class="i3"></i>获得的平台道具奖励将直接发放在账号上，登录平台pc客户端可查看奖励
                </p>
                <p>
                    <i class="i4"></i>本活动结束后会清空所有“转转机会”及“雪花”
                </p>
                <p>
                    <i class="i5"></i>本活动所有符文石及酒豆有效期7天
                </p>
                <p>
                    <i class="i6"></i>最终解释权归《09电竞》所有
                </p>
            </div>
            <div class="mate-info"></div>

            <div class="mark" v-if="pop_show"></div>
        </div>
        <div :class="`pop ${pop_show=='toast'?'pop1':''}`" v-if="pop_show">
            <div class="tite" v-if="pop_show!=='toast'">{{ pop_show=='toast'?'中奖提示':'请选择兑换的奖励'}}</div>
            <div class="close" @click="close_pop()"></div>
            <div class="inner">
                <!-- 恭喜获得 -->
                <div v-if="pop_show=='toast'" class="toast">
                    <p class="p1">
                        <span>-恭喜获得-</span>
                    </p>
                    <p class="p2">{{prize?prize:'-'}}</p>
                    <div class="btns">
                        <ul>
                            <li class="sure" @click="close_pop()"></li>
                        </ul>
                    </div>
                </div>
                <!-- 自选礼包 -->
                <div v-else-if="pop_show=='c_reward'" class="c_reward">
                    <ul class="list">
                        <li :class="choose_id==i.id?'active':''" @click="choose_item = i; choose_id = i.id; choose_opt = d;" v-for="(i,d) in fd_item.items" :title="i.name" :key="d">
                            <img :src="'https://cdn.09game.com/resources/item/dj_'+i.id+'_200.png'" alt :title="i.name" />
                            <span v-if="i.id!=0">{{i.h_amount>0?(i.h_amount>=2000?'已拥有':'拥有'+i.h_amount+'天'):'未拥有'}}</span>
                            <p>
                                {{i.name}}
                                <em v-if="i.id!=0">（永久）</em>
                            </p>
                        </li>
                    </ul>
                    <div class="btn_box">
                        <div class="btn" @click="open_packet(choose_item, choose_opt, 1)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { isToday, setEndTime } from '@/utils/common'
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url
const shop_url = baseUrls.shop_url
const hd_url = 'https://hd.09game.com/turntable/'

export default {
    name: 'winter',
    data() {
        return {
            app_id: 91610,
            flag_top: true,
            tab: 1,
            token: this.$storage.getToken(),
            user_id: '',
            user_name: '',
            account_list: [],
            choose_opt: -1,
            choose_id: -1,
            choose_item: null,
            pop_show: '', //打开弹框的类型
            btn_lock: false, //防抖
            is_signed: -1, //是否签到 1已签到 0未签到 -1初始
            videoUrl: '', //预览地址
            videoName: '', //预览名称
            exchange_list: [],
            day_list: [],
            goodsList: [],
            i: 0, //转到哪个位置
            count: 0, //转圈初始值
            totalCount: 0, //转动的总圈数
            speed: 300, //转圈速度，越大越慢
            minSpeed: 200,
            timer: null,
            current_index: 0, //指定转到哪个奖品,
            prize: '', //中奖信息
            oPlay: true,
            timer_dice: false,
            dice_url: '1.png',
            step_now: 0,
            chance_id: 20151, //转盘机会id
            chance_amount: 0,
            snow_id: 20152, //雪花道具id
            snow_amount: 0,
            fd_item: {}, //自选礼包信息
            my_used_packet: [],
            log_list: [], //获奖记录
            user_info: {},
        }
    },
    mounted() {},
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (vm.$common.checkToken(vm.token)) {
                vm.$http.set_anchor(7, vm.token)
            }
        })
    },
    created() {
        // setEndTime('2023-12-31 23:59:59');
        this.requireToken()
    },
    methods: {
        // 查询是否已签到
        query_sign_info() {
            this.$http.q_hd('GetTurntableLog', hd_url, { token: this.token, type: 2 }).then((res) => {
                if (res.code == 0 && res.msg) {
                    this.is_signed = isToday(res.msg.create_time) ? 1 : 0
                } else {
                    this.is_signed = 0
                }
            })
        },
        // 查询转盘获取道具记录
        query_turn_log() {
            let _this = this
            this.log_list = []
            this.$http.q_hd('GetTurntableLog', hd_url, { token: this.token, type: 1 }).then((res) => {
                if (res.code == 0 && res.msg) {
                    for (let i in res.msg) {
                        let data = res.msg[i]
                        if (data.type == 2 && data.result) {
                            let result = parseInt(data.result.split(':')[0]) + 1
                            data.getId = JSON.parse(data['gift' + result + '_setting']).id
                            data.getMsg = JSON.parse(data['gift' + result + '_setting']).name
                        } else {
                            data.getId = data.item_id
                            data.getMsg = data.item_name
                        }
                        _this.log_list.push(data)
                    }
                }
            })
        },
        // 获取转盘信息
        getTurnTable() {
            this.$http.q_hd('GetTurntable', hd_url, { token: this.token }).then((res) => {
                if (res.code == 0 && res.msg && res.msg.length > 0) {
                    this.goodsList = res.msg
                }
                this.current_index = parseInt(res.step) % 24
                this.i = this.current_index
            })
        },
        // 查询活动相关接口
        async query_app() {
            var _this = this
            this.day_list = []
            this.exchange_list = []
            await this.$http.q_cfg_task(this.app_id).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        item.status = ''
                        item.over_step = 0
                        item.items = []
                        item.count = 0
                        if (item.task_id >= 500813 && item.task_id <= 500814) {
                            _this.day_list.push(item) //每日任务
                        }
                    }
                }
            })
            // 查询活动礼包
            await this.$http.q_cfg_packet(this.app_id).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        item.status = ''
                        item.items = []
                        item.name = ''
                        for (var i = 1; i <= 6; i++) {
                            var obj = item['gift' + i + '_setting']
                            if (obj) {
                                item.items.push(JSON.parse(obj))
                                item.name += JSON.parse(obj).name + '/ '
                            }
                        }
                        for (let day of _this.day_list) {
                            if (day.packet_id == item.packet_id) {
                                day.items = item.items
                            }
                        }
                        if (item.packet_id == 916101) {
                            _this.day_list.unshift(item)
                        }
                        if (item.packet_id >= 916105 && item.packet_id <= 916108) {
                            _this.exchange_list.push(item)
                        }
                        if (item.packet_id == 916104) {
                            _this.fd_item = item
                        }
                    }
                }
            })

            await this.$http.q_cfg_item(this.snow_id).then((res) => {
                if (res.code == 0) {
                    let obj = res.records[0]
                    let arr = obj.setting ? JSON.parse(obj.setting).ex : []
                    for (let i in this.exchange_list) {
                        let item = this.exchange_list[i]
                        item.count = 0
                        item.status = ''
                        for (let each of arr) {
                            if (item.packet_id == each.packet) {
                                item.count = each.count
                            }
                        }
                        this.$set(this.exchange_list, i, item)
                    }
                }
            })

            await this.query_my_task()
            await this.query_my_packet()
            await this.query_sign_info()

            this.chance_amount = this.query_my_item(this.chance_id)
            this.snow_amount = this.query_my_item(this.snow_id)
        },
        // 查询我的任务
        query_my_task() {
            var _this = this
            return this.$http.q_my_task(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        for (var i in _this.day_list) {
                            let day = _this.day_list[i]
                            if (day.task_id && day.task_id == item.task_id && isToday(item.create_time)) {
                                day.over_step = item.over_step
                                day.task = item
                            }
                        }
                    }
                }
            })
        },
        // 查询我的礼包
        query_my_packet() {
            var _this = this
            this.$http.q_my_packet(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        for (let day of _this.day_list) {
                            if (day.packet_id == item.packet_id) {
                                day.packet = item
                            }
                        }
                        if (item.packet_id == this.fd_item.packet_id) {
                            this.fd_item.packet = item
                        }
                    }
                }
                this.initPage()
            })
        },

        // 查询礼包使用情况
        async query_use_packet() {
            let _this = this
            _this.my_used_packet = []

            await this.$http.q_my_packet_use(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    let arr = []
                    for (let item of res.records) {
                        arr.push(item)
                    }

                    for (let a of arr) {
                        // if (a.packet_id == this.fd_item.packet_id) {
                        let result = parseInt(a.result.split(':')[0]) + 1
                        a.getId = JSON.parse(a['gift' + result + '_setting']).id
                        a.getMsg = JSON.parse(a['gift' + result + '_setting']).name
                        _this.my_used_packet.unshift(a)
                        // }
                    }
                }
            })
        },

        // 查询我的道具数量
        query_my_item(id) {
            var _this = this
            var amount = 0
            $.ajax({
                url: shop_url + JSON.stringify({ type: 'q_my_item', json: JSON.stringify({ item_id: id, token: this.token }) }),
                async: false,
                success: (res) => {
                    if (res.code == 0) {
                        amount = res.records[0].amount
                    }
                },
            })
            return amount
        },
        // 签到
        to_sign() {
            let text = ''
            let element = '.part-1 .task-item0 .btn'
            if (this.btn_lock) {
                return false
            }
            if (this.is_signed == 1) {
                return false
            }
            this.btn_lock = true
            this.$http.q_hd('TurntableSkin', hd_url, { token: this.token }).then((res) => {
                if (res.code == 0) {
                    text = '签到成功！'
                    this.$http.use_packet(this.day_list[0].packet_id, this.token).then((rr) => {
                        if (rr.code == 0) {
                        }
                        this.is_signed = 1
                        this.btn_lock = false
                        this.mate_show(element, text, -40)
                        this.chance_amount = this.query_my_item(this.chance_id)
                    })
                } else {
                    text = res.msg ? res.msg : '签到失败！'
                    this.btn_lock = false
                    this.mate_show(element, text, -40)
                }
            })
        },
        // 兑换
        exchange(item, index) {
            let text = ''
            let element = `.exchange-list .exchange${index} .btn`
            if (this.btn_lock) {
                return false
            }
            if (item.count > this.snow_amount) {
                return false
            }
            this.btn_lock = true
            this.$http.use_item(this.snow_id, this.token, item.count).then((res) => {
                if (res.code == 0) {
                    text = '兑换成功！'
                    this.snow_amount = this.query_my_item(this.snow_id)
                    this.initPage()
                    this.btn_lock = false
                    this.mate_show(element, text, -40)
                } else {
                    text = res.info ? res.info : '兑换失败！'
                    this.btn_lock = false
                    this.mate_show(element, text, -40)
                }
            })
        },
        // 重置按钮状态
        initPage() {
            // 每日任务
            for (let day of this.day_list) {
                if (day.packet_id >= 916102 && day.packet_id <= 916103) {
                    let packet = day.packet
                    let task = day.task
                    if (packet && task && task.over_step >= task.total_step) {
                        if (packet.balance > 0 && packet.expire_days > 0) {
                            day.status = 'get'
                        } else if (packet.balance == 0 && packet.expire_days > 0) {
                            day.status = 'over'
                        } else {
                            day.status = ''
                        }
                    } else {
                        day.status = ''
                    }
                }
            }

            // 已拥有福袋
            let fd_pcg = this.fd_item.packet
            if (fd_pcg) {
                if (fd_pcg.balance > 0 && fd_pcg.expire_days > 0) {
                    this.fd_item.status = 'get'
                } else if (fd_pcg.balance == 0 && fd_pcg.expire_days > 0) {
                    this.fd_item.status = 'over'
                } else {
                    this.fd_item.status = ''
                }
            } else {
                this.fd_item.status = ''
            }

            this.$forceUpdate()
        },

        // 显示自选礼包弹框
        pick_zx() {
            for (let i in this.fd_item.items) {
                let item = this.fd_item.items[i]
                item.h_amount = item.id == 0 ? 0 : this.query_my_item(item.id)
            }
            this.pop_show = 'c_reward'
        },
        // 打开礼包  1自选礼包
        open_packet(item, index, type) {
            var _this = this
            if (this.btn_lock) {
                return false
            }
            let element = `.task-list .task-item${index} .btn`
            let text = ''
            if (type == 1) {
                // if (this.fd_item.status != 'get') { return false } //注释
                element = '.pop .c_reward .btn_box'
                if (this.choose_opt == -1) {
                    text = '请选择一个奖励！'
                    this.mate_show(element, text, -20)
                    return false
                }
                if (this.choose_id > 0 && item.h_amount >= 2000) {
                    text = '该头像已拥有，请更换奖励！'
                    this.mate_show(element, text, -20)
                    return false
                }
            } else {
                if (item.status != 'get') {
                    return false
                }
            }

            _this.btn_lock = true
            this.$http
                .use_packet(type == 1 ? this.fd_item.packet_id : item.packet_id, this.token, type == 1 ? this.choose_opt : 0)
                .then((res) => {
                    if (res.code == 0) {
                        text = '领取成功'
                        _this.btn_lock = false
                        _this.query_my_packet()
                        if (type == 1) {
                            _this.close_pop()
                            _this.mate_show(element, text, -30)
                            return false
                        }
                        _this.chance_amount = _this.query_my_item(_this.chance_id)
                        _this.mate_show(element, text, -30)
                    } else {
                        text = res.info ? res.info : '领取失败'
                        _this.btn_lock = false
                        _this.mate_show(element, text, -30)
                    }
                })
        },

        close_pop() {
            if (this.pop_show == 'c_reward') {
                this.choose_id = -1
                this.choose_opt = -1
                this.choose_item = null
            } else if (this.pop_show == 'toast') {
                this.prize = ''
                if (this.step_now != 6) {
                    this.current_index -= this.step_now
                    this.goBack()
                } else {
                    this.btn_lock = false
                    this.query_my_packet()
                }
            }
            this.pop_show = ''
        },

        // 滚动
        roll() {
            let _this = this
            this.i++
            //计算转圈次数
            if (this.i >= this.goodsList.length) {
                this.i = 0
                this.count++
            }
            //满足转圈数和指定位置就停止
            if (this.count >= this.totalCount && this.i == this.current_index) {
                this.pop_show = 'toast'
                this.snow_amount = this.query_my_item(this.snow_id)
                clearTimeout(this.timer_dice)
                // setTimeout(() => {
                //     _this.btn_lock = false
                // }, 500)
            } else {
                this.timer_dice = setTimeout(() => {
                    this.roll()
                }, this.speed)
            }
        },
        // 回退
        goBack() {
            let _this = this
            this.i--
            //计算转圈次数
            if (this.i <= 0) {
                this.i = 0
            }
            //满足转圈数和指定位置就停止
            if (this.i == this.current_index) {
                clearTimeout(this.timer_dice)
                setTimeout(() => {
                    _this.btn_lock = false
                }, 500)
            } else {
                this.timer_dice = setTimeout(() => {
                    this.goBack()
                }, this.minSpeed)
            }
        },

        // 开始投色子
        rollDice() {
            let _this = this
            if (this.btn_lock) {
                return false
            }
            if (this.chance_amount <= 0) {
                return false
            }
            let element = '.part-2 .btn'
            let text = ''
            this.btn_lock = true
            this.$http.q_hd('UserRolldice', hd_url, { token: this.token }).then((res) => {
                if (res.code == 0 && res.msg) {
                    text = res.msg ? res.msg : '操作成功'
                    this.step_now = res.msg.step
                    this.prize = res.msg.item_name
                    this.chance_amount = this.query_my_item(this.chance_id)
                    this.showDiceGif()
                    // _this.mate_show(element, text, -30)
                } else {
                    this.btn_lock = false
                    text = res.msg ? res.msg : '操作失败，请联系管理员'
                    _this.mate_show(element, text, -30)
                }
            })
        },
        // 显示筛子动图
        showDiceGif() {
            let _this = this
            let random_num = this.rand(700, 1200)
            if (_this.oPlay) {
                _this.oPlay = false
                _this.dice_url = 'dice.gif'
                //随机时间后，将动态图替换为随机点数的图片
                var timer = setTimeout(() => {
                    _this.dice_url = `${_this.step_now}.png`
                    _this.oPlay = true
                }, random_num)
            }
            _this.current_index = (_this.current_index + parseInt(_this.step_now)) % 24

            this.timer_dice = setTimeout(() => {
                _this.roll()
            }, random_num + 500)
        },
        change_tab(item) {
            this.tab = item
            if (item == 4) {
                this.query_turn_log()
            }
        },
        requireToken() {
            var Ucookie = this.token
            if (Ucookie != null) {
                var now = new Date().getTime()
                if (now >= Ucookie.split('-')[3] * 1000) {
                    //token过期
                    this.get_auth()
                } else {
                    this.init()
                }
            } else {
                this.get_auth()
            }
        },
        get_auth() {
            window.location.replace(base_url + '/GetWxOpenid?fromPage=winter')
        },
        async init() {
            this.token = this.$storage.getToken()
            this.user_id = this.token.split('-')[0]
            this.tab = 1
            await this.$http.getUserInfo(this.token).then((res) => {
                if (res.result == 0 && res.temp) {
                    this.user_info = Object.assign({}, this.user_info, res.temp)
                    this.$storage.setUserId(this.user_info.user_id)
                    this.$storage.setUserName(this.user_info.name)
                    this.$storage.setHeadId(this.user_info.avtar_head)
                    this.$storage.setUserLevel(this.user_info.level)
                    this.$storage.setUserFlag(this.user_info.flag)
                    this.user_id = this.user_info.user_id
                    this.user_name = this.user_info.name
                }
            })
            this.$http.getAllUser(this.token).then((res) => {
                if (res.result == 0 && res.msg && res.msg.length > 0) {
                    this.account_list = res.msg
                    this.$storage.setAccountList(JSON.stringify(res.msg))
                } else {
                    this.account_list = []
                }
            })
            this.getTurnTable()
            this.query_app()
        },
        rand(min, max) {
            if (min > max) {
                var mid = min
                min = max
                max = mid
            }
            return parseInt(Math.random() * (max - min + 1) + min)
        },
        mate_show(element, text, offsetTop, offsetLeft = 5) {
            $('.mate-info').html(text)
            var width1 = $(element).width()
            var width = $('.mate-info').width() + 44
            var offWidth = (width1 - width) / 2
            var top = $('.content').offset().top
            var cssTop = $(element).offset().top - top + offsetTop
            var cssLeft = $(element).offset().left + offWidth + offsetLeft
            var css = {
                top: cssTop,
                left: cssLeft,
            }
            if (this.timer) {
                clearTimeout(this.timer)
            }
            $('.mate-info').show().css(css)
            this.timer = setTimeout(function () {
                $('.mate-info').hide().html('')
            }, 3000)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/winter/index.scss';
</style>




// WEBPACK FOOTER //
// src/view/winter.vue